
export enum Tool {
  Pencil = 'Pencil',
  LargePencil = 'LargePencil',
  Bucket = 'Bucket',
  Rect = 'Rect',
  Circle = 'Circle',
  Line = 'Line',
  Text = 'Text',
  Copy = 'Copy',
  Paste = 'Paste'
}

export enum PMode {
  PMODE1 = 'PMODE1',
  PMODE4 = 'PMODE4'
}

export enum ExportFormat {
  PNG = 'PNG',
  C = 'C',
  ASM = 'ASM'
}

export type ColorHex = '#00FF00' | '#FF0000' | '#FFFF00' | '#0000FF';

export interface Point {
  x: number;
  y: number;
}
